const BULLET_REGEX = /[•●▪▫‣⁃◦]/g;

export const hasBullet = (text: string): boolean => {
  return BULLET_REGEX.test(text);
};

export const formatTextWithBullets = (text: string): string => {
  // First add newlines before bullet points
  let formatted = text.replace(/([•●▪▫‣⁃◦])/g, "\n$1");
  
  // Then add newlines after bullet-pointed lines (before the next bullet or at end)
  formatted = formatted.replace(/([•●▪▫‣⁃◦][^\n•●▪▫‣⁃◦]*?)(?=\n[•●▪▫‣⁃◦]|$)/g, "$1\n");
  
  return formatted;
};
